import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LockedFeature = ({ title, description, requiredPlan = "Business / Branded", testId }) => (
  <div
    data-testid={testId}
    className="relative overflow-hidden rounded-xl border border-ink-600 bg-ink-800 p-8 text-center"
  >
    <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-gold/10">
      <Lock className="h-5 w-5 text-gold" />
    </div>
    <span className="inline-flex items-center rounded-full border border-gold/30 bg-gold/10 px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-gold">
      Paid upgrade
    </span>
    <h3 className="mt-4 text-xl font-medium text-slate-100">{title}</h3>
    <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-slate-400">{description}</p>
    <p className="mt-3 font-mono text-xs text-slate-500">Included from the {requiredPlan} plan</p>
    <Button asChild className="mt-6 bg-gold text-ink-900 hover:bg-gold-light">
      <Link to="/app/plans" data-testid={`${testId}-upgrade-link`}>
        <Sparkles className="mr-2 h-4 w-4" /> View upgrade options
      </Link>
    </Button>
  </div>
);
